<script setup lang="ts">
  import { computed } from 'vue';

  const props = defineProps<{
    date: string | null | undefined;
  }>();

  const hasDate = computed(() => {
    const value = props.date?.trim();

    return Boolean(value) && value !== '-';
  });
</script>

<template>
  <section
    v-if="hasDate"
    data-testid="document-control-vigencia-section"
    class="border-t border-gray-02 py-6"
  >
    <div>
      <span class="text-[var(--theme-secondary-ink)] text-[15px] font-semibold">Vigência</span>

      <div class="mt-8 max-w-[236px] flex flex-col gap-2 text-gray-700">
        <span class="font-semibold text-sm">Data</span>
        <span
          data-testid="document-control-vigencia-date"
          class="flex h-12 items-center rounded-lg border border-gray-02 bg-[rgba(227,227,227,0.20)] px-5 text-sm text-gray-07"
        >
          {{ date }}
        </span>
      </div>
    </div>
  </section>
</template>
